export default __webpack_public_path__ + "static/media/personal-portfolio.593080f5.png";